import iziToast from 'izitoast/dist/js/iziToast.min.js';
import Message from "../components/Message";

export default (function (w, d) {
    'use strict';

    function PasswordResetConfirmationController() {
        this.initController();
    }

    PasswordResetConfirmationController.prototype.initController = function () {
        $('button[name="change_password"]').on('click', function () {
            var form = $('#reset_form');
            var action = form.attr('action');
            var formData = form.serialize();

            $.ajax({
                method: 'post',
                url: action,
                data: formData,
                beforeSend: function () {
                },
                success: function (response) {
                    if (response.status === 'success') {
                        window.location.href = response.url;
                        // iziToast.show({
                        //     message: response.message,
                        //     backgroundColor: '#fff',
                        //     position: 'topRight',
                        //     timeout: 5000,
                        //     progressBarColor: '#fac4bc',
                        //     overlayColor: 'rgba(0, 0, 0, 0)',
                        //     class: 'success-prof',
                        // });

                        $('form#reset_form input').val('');
                    } else {
                        new Message(response.message, 'error');
                    }
                },
                complete: function () {
                },
                error: function () {
                    new Message('Unexpected error', 'error');
                }
            });
        });
    }

    return PasswordResetConfirmationController;
}(window, document));

